import {signMessage} from './sign.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';

import {ethers} from 'ethers';

const SPORE_MESSAGE = "A new spore.";
export const newSpore = (sporeHash, tokenId=0) => {
    return new Promise(async (resolve) => {
        let {account, flatSignature, splitSignature} = await signMessage(SPORE_MESSAGE);

        // now store this signed message on the ropsten contract
        let {r,s,v} = splitSignature;
        
        let body = {
            r,
            s,
            v,
            message: SPORE_MESSAGE,
            sporeHash: ipfsHashToBytes32(sporeHash),
            tokenId: tokenId
        };
        
        let baseURL = "https://zequencer.io";
        if (window.location.hostname.includes("localhost")) {
            // baseURL = "";
        }

        fetch(baseURL + '/newSpore/' , {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                console.log("response=", resp);
                resolve(resp.transactionHash);
            });
    });
};
